exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/_pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

